// src/app/services/posthog.service.ts
import { DestroyRef, Injectable, NgZone } from '@angular/core';
import posthog, { Properties } from 'posthog-js';
import { environment } from '../../environments/environment';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private initialized = false;

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.initPostHog();
  }

  private initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '2026-01-30',
      });

      // Opcional (recomendado SPA): pageviews por navegación
      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
          posthog.capture('$pageview');
        }
      });

      this.initialized = true;
    });
  }

  capture(event: string, props?: Properties) {
    if (!this.initialized) return;
    posthog.capture(event, props);
  }

  identify(distinctId: string, props?: Properties) {
    if (!this.initialized) return;
    posthog.identify(distinctId, props);
  }

  reset() {
    if (!this.initialized) return;
    posthog.reset();
  }
  register(props: Properties): void {
    if (!this.initialized) return;
    posthog.register(props);
  }
}
